import { gtb as gtbBase } from "@thirdparty/companies";

import { Routes } from "./Routes";
import { GtbCustomApp } from "./types";

export const gtb: GtbCustomApp = {
  ...gtbBase,
  routes: {
    paths: ["/", "/:eventId"],
    Component: Routes,
  },
};
